module.exports = __webpack_public_path__ + "static/media/breadcrumb-arrow.c0c2f315.svg";